import { createUseStyles} from 'react-jss'

export const useStyles = () => createUseStyles((theme) => ({
    '@global': {
        body: {
            backgroundColor: ("white !important")                
        }
    }
}))